/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { Integrations } from "@sentry/tracing";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/browser";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { store, persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <section className="flexWrapper">
      <PersistGate loading={null} persistor={persistor}>
        <ToastContainer
          style={{ width: "40rem", padding: "20px", borderRadius: "8px" }}
        />
        <App />
      </PersistGate>
    </section>
  </Provider>
);

serviceWorker.unregister();
